import { render, staticRenderFns } from "./ApoyoEstudiantil.vue?vue&type=template&id=f787fc6c&scoped=true&"
import script from "./ApoyoEstudiantil.vue?vue&type=script&lang=js&"
export * from "./ApoyoEstudiantil.vue?vue&type=script&lang=js&"
import style0 from "./ApoyoEstudiantil.vue?vue&type=style&index=0&id=f787fc6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f787fc6c",
  null
  
)

export default component.exports